<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Map</router-link>
      <span style="font-weight: 900; font-size:22px; line-height:1rem">
        |
      </span>
      <router-link to="/donate">Donate</router-link>
      <!-- <span style="font-weight: 900; font-size:22px; line-height:1rem">
        |
      </span>
      <router-link to="/Secret">Secret</router-link> -->
      <TopHeader></TopHeader>
    </div>
    <router-view />
  </div>
</template>

<script>
import TopHeader from "@/components/Top-Header.vue";

export default {
  name: "Top-Header",
  components: {
    TopHeader
  }
};
</script>

<style lang="scss">
.mapboxgl-popup-close-button {
  top: 5px !important;
  right: 5px !important;
  color: #adadad;
  position: absolute;
  transform: scale(2);
  &:focus {
    border: none;
    outline: none;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0) !important;
  }
}

.mapboxgl-popup {
  transform: none !important;
  top: 15%;
  left: 10px;
}
.mapboxgl-popup-anchor-top .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-center .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-left .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-right .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip {
  display: none !important;
}

.mapboxgl-popup-content {
  position: fixed;
  top: calc(
    80px / 2 + 30px
  ); //half the length of the logo placement + 30px spacing
  // top: calc(
  //   38.5px + 40px + 10px + 120px + 100px
  // ); //height of nav + height of logo + buffer
  left: 10px;
  max-width: 200px;
  padding: 10px 10px 0px;
  color: #e2e2e2;
  background: #363636 !important;
  box-shadow: 2px 2px 4px grey !important;
  text-align: center;

  h5 {
    margin: auto 20px 10px 20px;
  }

  img {
    object-fit: cover; // centers image in div */
    width: 150px;
    height: 100px;
    border: solid 1px grey;
  }
}

.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
  border-top-color: #363636 !important;
  border-bottom-color: #363636 !important;
  // border-right-color: #363636 !important;
  // border-left-color: #363636 !important;
}

.yelp {
  border: none;
  cursor: pointer;
  height: 16px;
  width: 16px;
  background-size: cover;

  &.coffee {
    background-image: url("./assets/svgs/coffee-solid.svg");
    color: #a5a5a5;
    height: 12px;
    width: 16px;
  }
  &.bars {
    background-image: url("./assets/svgs/glass-martini-alt-solid.svg");
    color: #791010;
  }
  &.restaurants {
    background-image: url("./assets/svgs/utensils-solid.svg");
    color: #868686;
    height: 16px;
    width: 13px;
  }
  &.museums {
    background-image: url("./assets/svgs/landmark-solid.svg");
    color: #6aa4be;
  }
  &.breweries {
    background-image: url("./assets/svgs/beer-solid.svg");
    color: #e0b72e;
    height: 16px;
    width: 15px;
  }
  &.bikeshops {
    background-image: url("./assets/svgs/biking-solid.svg");
    color: #358680;
    height: 14px;
    width: 18px;
  }
  &.farm {
    background-image: url("./assets/svgs/seedling-solid.svg");
    color: #169616;
    height: 16px;
    width: 16px;
  }
}

body {
  margin: 0px;
}
.stateColor {
  color: red;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  /*animations & transitions*/
  transition: all 0.4s;
}
#nav {
  position: fixed;
  width:100%;
  height: 44px;
  top: 0px;
  padding: 10px;
  padding-left: calc(
    min(10px + 14vw + 10px, 10px + 80px + 10px)); //calc'ing the min between mobile which uses 14vw logo width, and 80px on desktop... calc is based off of: logo left space + logo width + logo right space
  background-color: #363636;
  color: #7c7c7c;
  & a {
    font-weight: bold;
    color: #cacaca;
  }
  & a.router-link-exact-active {
    color: #42b983;
  }
}
.mapboxgl-user-location-dot,
.mapboxgl-user-location-dot:before {
  left: -0.1px;
}
.mapboxgl-ctrl-top-left {
  width: 100vw;
  display: flex;
  justify-content: center;
  margin-left: 0px;
}
.mapboxgl-ctrl-top-left.mapbox-ctrl {
  margin: 10px 0px 0px 0px;
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl-geocoder {
  margin: 10px 0px 0px 0px;
  width: 70vw !important;
  border: solid 1px grey;
}
.mapboxgl-ctrl-geocoder.mapboxgl-ctrl {
  margin: 10px 0px 0px 0px !important;
}

.mapboxgl-ctrl-geocoder--button {
  display: block !important;
  background-color: rgb(255, 255, 255) !important;
  outline: none !important;

  > svg {
    fill: #696969;
  }

}

.mapboxgl-ctrl-top-right .mapboxgl-ctrl.mapboxgl-ctrl-group {
  border: solid 1px grey;
}
.mapboxgl-ctrl-top-right .mapboxgl-ctrl.mapboxgl-ctrl-group button {
  width: calc(15vw - 25px);
  max-width: 40px;
}
</style>
